"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Overlay = void 0;
/* eslint-disable jsx-a11y/no-autofocus */
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var focus_1 = require("@react-aria/focus");
var overlays_1 = require("@react-aria/overlays");
var SelectContext_1 = require("../../context/SelectContext");
var Overlay_module_scss_1 = __importDefault(require("./Overlay.module.scss"));
var Overlay = function (_a) {
    var _b;
    var children = _a.children, triggerRef = _a.triggerRef;
    // Handle events that should cause the menu to close,
    // e.g. blur, clicking outside, or pressing the escape key.
    var state = (0, SelectContext_1.useSelectContext)().state;
    var popoverRef = react_1["default"].useRef(null);
    var popoverProps = (0, overlays_1.usePopover)({
        triggerRef: triggerRef,
        popoverRef: popoverRef,
        isNonModal: true,
        placement: "bottom left"
    }, state).popoverProps;
    var width = (((_b = triggerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) || {}).width;
    // Wrap in <FocusScope> so that focus is restored back to the trigger when the menu is closed
    // and auto focus on the first focusable item after loading. (disable eslint no-autofocus error for it)
    // In addition, add hidden <DismissButton> components at the start and end of the list
    // to allow screen reader users to dismiss the popup easily.
    var contents = (react_1["default"].createElement("div", __assign({}, popoverProps, { ref: popoverRef, style: __assign(__assign({}, popoverProps.style), { width: width }), className: Overlay_module_scss_1["default"].menuPopup }),
        react_1["default"].createElement(focus_1.FocusScope, { contain: true, autoFocus: true, restoreFocus: true },
            react_1["default"].createElement(overlays_1.DismissButton, { onDismiss: state.close }),
            children,
            react_1["default"].createElement(overlays_1.DismissButton, { onDismiss: state.close }))));
    return react_dom_1["default"].createPortal(contents, document.body);
};
exports.Overlay = Overlay;
//# sourceMappingURL=Overlay.js.map